<template>
  <v-dialog
    v-model="show"
    persistent
    :max-width="dialogWidth"
  >
    <v-card class="dialog-detail">
      <v-card-title class="dialog">
        <v-icon
          :color="dialogColor"
          x-large
          class=" mb-4 mt-2"
        >
          {{ this.successIcon }}
        </v-icon><br>
        <b class="text-block">{{ this.successAlert }}</b>
      </v-card-title>
      <v-card-text v-if="this.successDetail !==''">
        {{ this.successDetail }}
      </v-card-text>
      <detail-data
        v-if="showDetailData"
        :detailDataArray="this.detailData"
      >
      </detail-data>
      <v-card-text
        v-if="this.showCopyIcon"
        class="dialog-detail dialog-bg--green pt-4 detail-box mb-2"
      >
        {{ this.successAlertDetail }}
        <button
          type="button"
          v-if="this.showCopyIcon"
          v-clipboard:copy="copyData"
          v-clipboard:success="onCopy"
        >
          【{{ $t('copy') }}】
        </button>
        <v-btn
          color="green darken-1"
          v-if="showDetailBtn"
          outlined
          class="mt-2"
          @click.stop="detailBtnFunction"
        >
          <v-icon left>
            {{ this.detailBtnIcon }}
          </v-icon>
          {{ this.detailBtn }}
        </v-btn>
      </v-card-text>
      <v-card-text v-if="showTextField">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-textarea
                :label="titleFirst"
                :value="this.titleFirstDetail"
                class="dialog-detail"
                color="mainColor"
                auto-grow
                row-height="6"
                filled
                readonly
              ></v-textarea>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <v-textarea
                :label="titleSecond"
                :value="titleSecondDetail"
                color="mainColor"
                auto-grow
                row-height="6"
                filled
                readonly
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          class="mb-2"
          v-if="showCancelBtn"
          @click="show = false"
        >
          {{$t('closeDialog')}}
        </v-btn>
        <v-btn
          :color="dialogColor"
          depressed
          :dark="btnTextDark"
          class="mb-2"
          @click.stop="confirm"
          v-if="this.actionBtn.length != 0"
        >
          {{ this.actionBtn }}
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
    <v-snackbar
      v-model="snackbar"
      class="snackbar"
      dark
      color="success"
      :timeout="timeout"
    >
      <v-icon class="mr-2">mdi-check-circle</v-icon>
      {{ $t('copied') }}

      <template v-slot:action="{ attrs }">
        <v-btn
          depressed
          small
          light
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{$t('close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog>
</template>

<script>
import detailData from './detailData.vue';

export default {
  components: {
    detailData,
  },
  props: {
    dialogWidth: Number,
    value: Boolean,
    showCopyIcon: Boolean,
    showCancelBtn: Boolean,
    showDetailBtn: Boolean,
    showDetailData: Boolean,
    showTextField: Boolean,
    showText: Boolean,
    btnTextDark: Boolean,
    dialogColor: String,
    successIcon: String,
    successAlert: String,
    successDetail: String,
    successAlertDetail: String,
    actionBtn: String,
    detailBtn: String,
    detailBtnIcon: String,
    detailBtnFunction: Function,
    titleFirst: String,
    titleFirstDetail: String,
    titleSecond: String,
    titleSecondDetail: String,
    detailData: Object,
  },
  data: () => ({
    snackbar: false,
    timeout: 2000,
    copyText: 'copied',
  }),
  methods: {
    confirm() {
      this.show = false;
      this.$emit('success-child-method');
    },
    onCopy() {
      this.snackbar = true;
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    copyData() {
      if (this.detailData !== undefined && this.detailData !== null
        && this.detailData.moreDetail !== undefined && this.detailData.moreDetail !== null
        && this.detailData.moreDetail.length > 0) {
        return this.detailData.moreDetail
          .map((item) => `${item.detailTitle}: ${item.detailMessage}`)
          .join('\n');
      }
      return this.successAlertDetail;
    },
  },
};
</script>

<style scoped lang="scss">
  @import '@/scss/modules/m-dialog.scss';

  .detail-box {
    margin: 0 auto;
    width: 90%;
  }
  .snackbar {
    width: 50%;
    margin: 0 auto;
  }
  .text-block {
    white-space: normal;
  }
</style>
